module.exports = __webpack_public_path__ + "media/resume_rev/resumerev-rally-lockup-2870bc66.png";